export default "__VITE_ASSET__CDPYCHAQ__"